import { render, staticRenderFns } from "./BackendNotFooter.vue?vue&type=template&id=462f214c"
import script from "./BackendNotFooter.vue?vue&type=script&lang=js"
export * from "./BackendNotFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('462f214c')) {
      api.createRecord('462f214c', component.options)
    } else {
      api.reload('462f214c', component.options)
    }
    module.hot.accept("./BackendNotFooter.vue?vue&type=template&id=462f214c", function () {
      api.rerender('462f214c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/variations/BackendNotFooter.vue"
export default component.exports